export default __webpack_public_path__ + "static/media/object_laser.266ca731.png";